import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Progression} from '../../../../../../ispm-web/shared/modules/common';
import { StringUtils } from '../utils/String.utils';
import { EntityTreeService } from './entity-tree.service';

export const PROGRESSION_RESOURCE_TYPE: string = 'progression';
@Injectable()
export class ProgressionService {

  private commonDocIDs: string[] = [];

  constructor(private service: EntityTreeService) {
  }

  create(name: string, additionalProperties: { [prop: string]: any}): Observable<Progression> {
    const prog: Progression = this.generateProgression(name, additionalProperties);
    return (this.service.create(PROGRESSION_RESOURCE_TYPE , prog) as Observable<Progression>);
  }

  search(name: string): Observable<Array<Progression>> {
    return (this.service.search(PROGRESSION_RESOURCE_TYPE , { context: EntityTreeService.getRevisionId(), name: name}) as Observable<Array<Progression>>);
  }

  update(progression: Progression): Observable<Progression> {
    if( progression.name === 'PATHWAY_TEST') {
      progression.data.commonDocuments = this.commonDocIDs;
    }
    return (this.service.update(PROGRESSION_RESOURCE_TYPE, progression) as Observable<Progression>);
  }

  get(progressionId: string): Observable<Progression> {
    return (this.service.get(PROGRESSION_RESOURCE_TYPE, progressionId) as Observable<Progression>);
  }

  setCommonDocuments(commonDocIds: string[]) {
    this.commonDocIDs = commonDocIds;
  }

  private generateProgression(name: string, additionalProperties: { [p: string]: any }){
    const id = StringUtils.generateGuid();
    return {
      id: id,
      name: name,
      data: {
        id: id,
        additionalProperties: additionalProperties
      },
      meta: {
        lastUpdated: null,
        created: null,
        versionId: null,
      },
      context: [{ reference: EntityTreeService.getRevisionId(), resourceType: 'WorkflowRevision'}],
      resourceType: PROGRESSION_RESOURCE_TYPE
    };
  }

}
